import { DataTable, Heading, Loader } from "@/components";
import { Button, Input } from "@/components/ui";
import useCategory from "./useCategory";
import { Search } from "lucide-react";
import { Outlet } from "react-router-dom";

const Category = () => {
  const {
    onAdd,
    isMobile,
    globalFilter,
    setGlobalFilter,
    columns,
    categoryList,
    isCategoryListLoading,
    isView,
  } = useCategory();

  return (
    <div>
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title="Category" />
          {isMobile && !isView && (
            <Button onClick={onAdd} className="px-2">
              + Add Category
            </Button>
          )}
        </div>
        <div className="flex flex-row items-center gap-4">
          <Input
            type="text"
            placeholder="Search"
            value={globalFilter ?? ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="w-full sm:w-72 bg-white h-[40px]"
            startIcon={<Search className="w-4 h-4" />}
          />
          {!isMobile && !isView && (
            <Button onClick={onAdd}>+ Add Category</Button>
          )}
        </div>
      </div>

      {/* Responsive Table */}
      {isCategoryListLoading ? (
        <Loader />
      ) : (
        <DataTable
          columns={columns}
          data={(categoryList?.data || [])?.sort(
            (a: any, b: any) =>
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          )}
          setGlobalFilter={setGlobalFilter}
          globalFilter={globalFilter}
        />
      )}
      <Outlet />
    </div>
  );
};

export default Category;
